import Image from "next/image";
import { homePageCommunityLink, homePageProductList } from "../constants";

interface FooterProps {
  onDownloadClick: () => void;
}

export function Footer({ onDownloadClick }: FooterProps) {
  return (
    <div className="bg-black py-8 md:py-16">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:justify-between md:items-start space-y-8 md:space-y-0">
          {/* Logo and Contact */}
          <div className="flex-shrink-0">
            <div className="flex items-center mb-2">
              <Image
                src="/logo.svg"
                alt="Fellou"
                width={126}
                height={56}
                className="h-10 md:h-14 w-auto"
              />
            </div>
            <div className="text-gray-400 text-sm mb-4 md:mb-6">Contact Us | hi@fellou.ai</div>
            <div className="flex items-center space-x-4">
              {homePageCommunityLink.map((item, index) => (
                <a
                  key={index}
                  href={item.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors text-lg md:text-base"
                >
                  <i className={item.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Footer Links */}
          <div className="grid grid-cols-2 md:flex md:space-x-12 gap-6 md:gap-0">
            <div>
              <h4 className="text-white text-base md:text-lg font-medium mb-3 md:mb-4">Product</h4>
              <div className="space-y-2">
                {homePageProductList[0].map((item, index) => {
                  // Special handling for Download link
                  if (item.title === "Download") {
                    return (
                      <button
                        key={index}
                        onClick={onDownloadClick}
                        className="block text-gray-400 text-sm hover:text-white transition-colors text-left"
                      >
                        {item.title}
                      </button>
                    );
                  }

                  return (
                    <a
                      key={index}
                      href={item.path}
                      target={item.toway === 0 ? "_blank" : "_self"}
                      rel="noopener noreferrer"
                      className="block text-gray-400 text-sm hover:text-white transition-colors"
                    >
                      {item.title}
                    </a>
                  );
                })}
              </div>
            </div>

            <div>
              <h4 className="text-white text-base md:text-lg font-medium mb-3 md:mb-4">Framework</h4>
              <div className="space-y-2">
                {homePageProductList[1].map((item, index) => (
                  <a
                    key={index}
                    href={item.path}
                    target={item.toway === 0 ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    className="block text-gray-400 text-sm hover:text-white transition-colors"
                  >
                    {item.title}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-white text-base md:text-lg font-medium mb-3 md:mb-4">Company</h4>
              <div className="space-y-2">
                {homePageProductList[2].map((item, index) => (
                  <a
                    key={index}
                    href={item.path}
                    target={item.toway === 0 ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    className="block text-gray-400 text-sm hover:text-white transition-colors"
                  >
                    {item.title}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-white text-base md:text-lg font-medium mb-3 md:mb-4">Legal</h4>
              <div className="space-y-2">
                {homePageProductList[3].map((item, index) => (
                  <a
                    key={index}
                    href={item.path}
                    target={item.toway === 0 ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    className="block text-gray-400 text-sm hover:text-white transition-colors"
                  >
                    {item.title}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
